import { Box, FormLabel, IconButton, Stack, TextField } from '@chronosphereio/chrono-ui';
import { DeleteOutline as DeleteIcon } from 'mdi-material-ui';
import { RefObject, useState } from 'react';
import { ThresholdOptions } from '../../../core';
import { ThresholdColorPicker } from './ThresholdColorPicker';

export interface ThresholdInputProps {
  label: string;
  color: string;
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onColorChange: (color: string) => void;
  onBlur: () => void;
  onDelete: () => void;
  inputRef?: RefObject<HTMLInputElement | null>;
  mode?: ThresholdOptions['mode'];
}

export function ThresholdInput({
  inputRef,
  label,
  color,
  value,
  mode,
  onChange,
  onColorChange,
  onBlur,
  onDelete,
}: ThresholdInputProps) {
  const [key, setKey] = useState(0); // use key to cause input to lose focus when pressing enter
  return (
    <Stack flex={1} direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <FormLabel htmlFor={label}>{label}</FormLabel>
        <TextField
          id={label}
          key={key}
          inputRef={inputRef}
          type="number"
          value={value === 0 ? '' : value}
          placeholder="0"
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onBlur();
              setKey(key + 1);
            }
          }}
          InputProps={{
            endAdornment: mode === 'Percent' ? <Box paddingLeft={1}>%</Box> : undefined,
          }}
          sx={{ width: '180px' }}
        />
        <ThresholdColorPicker label={label} color={color} onColorChange={onColorChange} />
      </Stack>
      <IconButton aria-label={`delete threshold ${label}`} size="small" onClick={onDelete}>
        <DeleteIcon />
      </IconButton>
    </Stack>
  );
}
